import { Component, Input } from '@angular/core';
import {
  RvBadgeComponent,
  type RvBadgeColor,
} from '../rv-badge/rv-badge.component';

@Component({
  selector: 'schedule-type-pill',
  templateUrl: './schedule-type-pill.component.html',
  standalone: true,
  imports: [RvBadgeComponent],
})
export class ScheduleTypePillComponent {
  @Input() scheduleTypeName: string = '';

  get badgeColor(): RvBadgeColor {
    if (this.scheduleTypeName === 'Replace') {
      return 'yellow';
    }

    if (this.scheduleTypeName === 'Include') {
      return 'blue';
    }

    return 'gray';
  }

  get badgeIcon(): string | null {
    if (this.scheduleTypeName === 'Replace') {
      return 'switch';
    }

    if (this.scheduleTypeName === 'Include') {
      return 'square-check';
    }

    return null;
  }
}
